import { gatewaySectorWorkFlows } from "../../../../../../../../gateways/gatewaySectorWorkFlows";

export const getTypeOfServices = async ({ categoryType }) => {
  const query = categoryType ? `?category=${encodeURIComponent(categoryType)}` : "";
  const res = await gatewaySectorWorkFlows.get(`/type-of-service${query}`);
  return res.data?.data ?? res.data;
};
